import {Component, ViewChild, ViewEncapsulation} from '@angular/core';
import {TableComponent} from "../../../shared/components/table/table.component";
import {AddressComponent} from "../backlog/address/address.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {PersonalDataComponent} from "./personal-data/personal-data.component";
import {ChangeStatusComponent} from "./change-status/change-status.component";
import {FundingComponent} from "./funding/funding.component";
import {GeneralService} from "../../../core/services/general.service";
import {EventsTableComponent} from "../event/events-table/events-table.component";
import {LocationComponent} from "./location/location.component";

@Component({
  selector: 'app-list',
  standalone: true,
    imports: [
        TableComponent
    ],
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ListComponent {
  @ViewChild(TableComponent) tableComponent!: TableComponent;
  configurationTable: any = {
    "columns": [
      {
        "id": "assignments.id",
        "title": "Asignación",
        "type": "text",
        "placeholder": "",
        "required": false,
        "hide": true
      },
      {
        "id": "assignments.assignment_status",
        "title": "Estatus",
        "type": "status",
        "placeholder": "--",
        "required": false,
        "options":[
          {"name":"Asignado","icon":"alert-circle", "class":"danger"},
          {"name":"Aceptado","icon":"user-check", "class":"warning"},
          {"name":"En proceso","icon":"truck", "class":"primary"},
          {"name":"Finalizado","icon":"check-circle", "class":"success"}
        ]
      },
      {
        "id": "service.id",
        "title": "Orden de servicio",
        "type": "text",
        "placeholder": "",
        "required": false,
        "hide": true
      },
      {
        "id": "service.created_at",
        "title": "Fecha",
        "type": "text",
        "placeholder": "--",
        "required": true
      },
      {
        "id": "client_data.name",
        "title": "Cliente",
        "type": "link",
        "placeholder": "--",
        "required": false,
        "action": {
          "type": "emmit",
          "fn": this.getPersonalDataClient.bind(this)
        },
      },
      {
        "id": "classification.configurableListsCode",
        "title": "Clasificación cliente",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service_details.service_type",
        "title": "Tipo de servicio",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "cityOrigin.configurableListsCode",
        "title": "Punto origen",
        "type": "link",
        "placeholder": "--",
        "required": false,
        "action": {
          "type": "emmit",
          "fn": this.getAddressOrigin.bind(this)
        },

      },
      {
        "id": "cityDestination.configurableListsCode",
        "title": "Punto destino",
        "type": "link",
        "placeholder": "--",
        "required": false,
        "action": {
          "type": "emmit",
          "fn": this.getAddressDestination.bind(this)
        },
      },
      {
        "id": "category_vehicle.description",
        "title": "Categoría vehiculo",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "vehicles.vehicle",
        "title": "Vehículo",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "vehicles.plates",
        "title": "Placas Vehículo",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      /*{
        "id": "vehicles.vehicle",
        "title": "Vehículo",
        "type": "link",
        "placeholder": "--",
        "required": false,
        "action": {
          "type": "emmit",
          "fn": this.changeStatus.bind(this)
        },
      },*/
      {
        "id": "service_details.bilingual_operator",
        "title": "Tipo conductor",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service.start_date",
        "title": "Fecha Inicio",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service.end_date",
        "title": "Fecha Fin",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service.passenger_name",
        "title": "Nombre del viajero",
        "type": "link",
        "placeholder": "--",
        "required": false,
        "action": {
          "type": "emmit",
          "fn": this.getPersonalDataPassenger.bind(this)
        },
      },
      {
        "id": "service.passenger_count",
        "title": "No de Pasajeros",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service.pickup_time",
        "title": "Horario PickUp",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service.airline",
        "title": "Línea aerea/vuelo",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "paymentStatus.configurableListsCode",
        "title": "Estatus de pago",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      /*{
        "id": "paymentStatus.configurableListsCode",
        "title": "Estatus de pago",
        "type": "link",
        "placeholder": "--",
        "required": false,
        "action": {
          "type": "emmit",
          "fn": this.changeStatus.bind(this)
        },
      },*/
      {
        "id": "paymentMethod.configurableListsCode",
        "title": "Método de pago",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "paymentMethod.configurableListsCode",
        "title": "Forma de pago",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "paymentMethod.configurableListsCode",
        "title": "Requiere factura",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "",
        "title": "Itinerario y/o Recomendaciones",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "",
        "title": "Actividad-termino-servicio",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service_details.additional_hour",
        "title": "Horas extra",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service_details.night_event",
        "title": "Evento Nocturno",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service_details.overnight_viaticum",
        "title": "Viáticos",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service_details.baby_seat",
        "title": "Baby seat",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "service_details.miscellaneous",
        "title": "Misceláneos",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "employee_data.name",
        "title": "Trasladista",
        "type": "link",
        "placeholder": "--",
        "required": false,
        "action": {
          "type": "emmit",
          "fn": this.getPersonalDataEmployee.bind(this)
        },
      },
      /*{
        "id": "assignments.assignment_status",
        "title": "Eventos",
        "type": "text",
        "placeholder": "--",
        "required": false
      },
      {
        "id": "assignments.assignment_status",
        "title": "Fecha: creación,asignación,aceptación,inicio y término",
        "type": "text",
        "placeholder": "--",
        "required": false
      },*/
      {
        "btnName": "Opciones",
        "actions": [
          {
            "btnName": "Eventos",
            "textConfirmation": "",
            "action": {
              "type": "emmit",
              "fn": this.modalEvents.bind(this)
            },
            "type":{
              "type":"btn-icon",
              "class": 'btn-pill btn-outline-secondary border border-secondary',
              "icons": 'alert-triangle'//help-circle
            }
          },
          {
            "btnName": "Fondear",
            "textConfirmation": "",
            "action": {
              "type": "emmit",
              "fn": this.getFunding.bind(this)
            },
            "type":{
              "type":"btn-icon",
              "class": 'btn-pill btn-outline-warning border border-warning',
              "icons": 'dollar-sign'
            }
          },
          {
            "btnName": "Cambiar Estatus",
            "textConfirmation": "",
            "action": {
              "type": "emmit",
              "fn": this.changeStatus.bind(this)
            },
            "type":{
              "type":"btn-icon",
              "class": 'btn-pill btn-outline-primary border border-primary',
              "icons": 'edit'
            }
          },
          {
            "btnName": "Geolocalización",
            "textConfirmation": "",
            "action": {
              "type": "emmit",
              "fn": this.getLocation.bind(this)
            },
            "type":{
              "type":"btn-icon",
              "class": 'btn-pill btn-outline-success border border-success',
              "icons": 'navigation'
            }
          },
          {
            "btnName": "Cancelar asignación",
            "textConfirmation": "",
            "action": {
              "type": "delete",
            },
            "type":{
              "type":"btn-icon",
              "class": 'btn-pill btn-outline-danger border border-danger',
              "icons": 'trash-2'
            }
          },
        ]
      }
    ],
    "config": "assignments",
    "sortColumn": "service.id",
    "sortDirection": "ASC",
    "title": "Servicios",
    "filterPrincipal": [
    ],
    "filters":[]
  };

  constructor(public modalList :NgbModal, private generalService : GeneralService) {

  }

  ngOnInit(){

  }
  changeStatus(row:any){
    let modal = this.modalList.open(ChangeStatusComponent, { centered: true });
    modal.componentInstance.data = row;
    modal.componentInstance.confirmAction = (data: any) => {
      if (this.tableComponent) {
        this.tableComponent.reloadTable();
      } else {
        this.generalService.showMessage('warn', 'Error! No fue posible recargar el tablero.');
      }
      modal.close();
    };
  }

  /********Cancelar Asignacion***/

  cancelAssigment(row :any){

  }

  /**
   * Function: para obtener los datos de empleado, cleinte o pasajero
   * @param row
   */
  getPersonalDataClient(row: any){
    let data = {type:'client', data:row};
    let modal = this.modalList.open(PersonalDataComponent, { centered: true });
    modal.componentInstance.data = data;
    modal.componentInstance.title = "Cliente";
    modal.componentInstance.confirmAction = (data: any) => {
      //ToDO
    };
  }

  getPersonalDataPassenger(row: any){
    let data = {type:'passenger', data:row};
    let modal = this.modalList.open(PersonalDataComponent, { centered: true });
    modal.componentInstance.data = data;
    modal.componentInstance.title = "Pasajero";
    modal.componentInstance.confirmAction = (data: any) => {
      //ToDO
    };
  }

  getPersonalDataEmployee(row: any){
    let data = {type:'employee', data:row};
    let modal = this.modalList.open(PersonalDataComponent, { centered: true });
    modal.componentInstance.data = data;
    modal.componentInstance.title = "Trasladista";
    modal.componentInstance.confirmAction = (data: any) => {
      //ToDO
    };
  }

  getFunding(row: any){
    let modal = this.modalList.open(FundingComponent, { centered: true, windowClass: 'modal-xl modal-dialog-centered' });
    modal.componentInstance.data = row;
    modal.componentInstance.confirmAction = (data: any) => {
      //ToDO
    };
  }

  modalEvents(row: any){
    let modal = this.modalList.open(EventsTableComponent, { centered: true, windowClass: 'modal-xl modal-dialog-centered' });
    modal.componentInstance.data = row;
    modal.componentInstance.confirmAction = (data: any) => {
      //ToDO
    };
  }

  getAddressOrigin(row: any){
    let data = {type:'origin', data:row};
    let modal = this.modalList.open(AddressComponent, { centered: true });
    modal.componentInstance.data = data;
    modal.componentInstance.title = "Origen";
    modal.componentInstance.confirmAction = (data: any) => {
      //ToDO
    };
  }
  getAddressDestination(row: any){
    let data = {type:'destination', data:row};
    let modal = this.modalList.open(AddressComponent, { centered: true });
    modal.componentInstance.title = "Destino";
    modal.componentInstance.data = data
    modal.componentInstance.confirmAction = (data: any) => {
      //ToDO
    };
  }

  //Función para abrir mapa
  getLocation(row: any){
    let modal = this.modalList.open(LocationComponent, {
      centered: true,
      size: 'xl', // Agrega esto para hacerlo extra large
      // O usa windowClass para un tamaño custom
      // windowClass: 'modal-fullscreen-lg'
    });
    modal.componentInstance.data = row;
    modal.componentInstance.confirmAction = (data: any) => {
      //ToDO
    };
  }
}
